module.exports = __webpack_public_path__ + "img/projects-icon.fd7c0242.svg";